// `beforeSend` for `Sentry.init` in main.tsx, kept here so the combined filtering is unit tested.

import type { ErrorEvent, EventHint } from '@sentry/react';
import type { installChunkLoadRecovery } from '~/lib/chunk-load-recovery';
import { isCustomEventRejection, isSentryReplayIframeCrash, isThirdPartyXhrFailure } from '~/lib/sentry-filters';
import { scrubEventUser } from '~/lib/sentry-pii';

type ChunkLoadRecovery = Pick<ReturnType<typeof installChunkLoadRecovery>, 'isRecoveredChunkLoadError'>;

export function createSentryBeforeSend(chunkLoadRecovery: ChunkLoadRecovery) {
  return (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
    // Third-party and SDK self-noise. Each predicate documents the ui-myaccount issue it was added
    // for; see ~/lib/sentry-filters.
    if (isCustomEventRejection(event, hint.originalException)) return null;
    if (isSentryReplayIframeCrash(event)) return null;
    if (isThirdPartyXhrFailure(event)) return null;
    // The chunk-load error the page is already reloading to recover from.
    if (chunkLoadRecovery.isRecoveredChunkLoadError(event, hint.originalException)) return null;
    // Stopgap: the package sets the customer's email as the Sentry user. Keep only the id.
    return scrubEventUser(event);
  };
}
